import React, { useState } from 'react';
import { BusinessClassSurveyProps } from './types';
import { Button } from '@trello/nachos/button';
import { MaxlengthTextarea } from 'app/src/components/MaxlengthTextarea';
import { forTemplate } from 'app/common/lib/util/i18n';

import styles from './BusinessClassFreeformSurvey.less';

const format = forTemplate('business_class_survey');

const MAX_LENGTH = 128;

export const BusinessClassFreeformSurvey: React.FunctionComponent<BusinessClassSurveyProps> = function BusinessClassFreeformSurvey({
  onSubmit,
  onDismiss,
}) {
  const [freeform, setFreeform] = useState('');

  const submitDisabled = freeform.length === 0;

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(freeform, true);
      }}
    >
      <label>
        <div className={styles.question}>{format('question')}</div>
        <MaxlengthTextarea
          autoFocus
          className={styles.freeform}
          maxLength={MAX_LENGTH}
          onChange={(e) => setFreeform(e.target.value)}
          value={freeform}
        />
      </label>
      <Button
        type="submit"
        isDisabled={submitDisabled}
        shouldFitContainer
        appearance={'primary'}
      >
        {format('submit')}
      </Button>
      <Button
        shouldFitContainer
        onClick={(e) => {
          e.preventDefault();
          onDismiss();
        }}
      >
        {format('no-thanks')}
      </Button>
    </form>
  );
};
